import RestApiService from './rest.api.service';
import 'js-cookie';
;
class BoardAPIService extends RestApiService {
    constructor() {
        super();
        super.authorized = true;
        super.updateContextPath('boards');
    }
    fetchAll() {
        return this.get('');
    }
    create(payload) {
        return this.post('', payload);
    }
    edit(payload) {
        return this.patch('', payload);
    }
}
export const boardAPIService = new BoardAPIService();
